/**
 * Backend request wrapper with error handling.
 */
import { ApiHost } from '@/lib/constants';
import { HttpMethod } from '@/lib/enums';
import type { IApiRequestConfig } from '@/lib/types';
import { backendRequest } from './back-end-manager';

export const authenticatedRequest = async ({
  method = HttpMethod.GET,
  isAuthenticated = true,
  apiHost = ApiHost.BackendService,
  apiVersion,
  ...rest
}: IApiRequestConfig) => {
  if (apiVersion === undefined) {
    apiVersion = apiHost === ApiHost.BackendService ? '/api' : '';
  }
  try {
    const response = await backendRequest({
      method,
      isAuthenticated,
      apiHost,
      apiVersion,
      ...rest,
    });
    if (rest.includeResponseHeaders) {
      return response;
    }
    return response.data;
  } catch (error: unknown) {
    const err = error as { status?: number; data?: Record<string, unknown> };
    const data = err.data;
    const apiError = data?.error as
      | { code?: string; message?: string; context?: unknown }
      | undefined;
    if (apiError?.message) {
      throw apiError;
    }
    throw error;
  }
};
